module.exports = __webpack_public_path__ + "img/data-quality-record-labels-level-2.c5825f43.svg";